import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/cennik',
    element: <PricingPage />,
  },
  {
    path: '/o-nas',
    element: <AboutPage />,
  },
  {
    path: '/kontakt',
    element: <ContactPage />,
  },
  {
    path: '/fotogaleria',
    element: <GalleryPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;